export const ADMIN_ADDRESS = "C5MnRcWRfyCg6ja9VQm8sQq3eDEVMWRQJNaXknczPUCA";
export const PROJECT_VAULT_ADDRESS = "CMzzY1F4dsMJEQapSZ5bmEQBRWa9MkrZkhqn25XG6oV1";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const FOUNDER_ADDRESS = "JC35ckhTm25Tt17fjZoxv2WbNHabaQvs8TQzRiToVWRT";
export const PHANTOM_APP_ID = "2280d51b-d33a-4d6c-a7a4-e532ba1ef60e";
export const NFT_COLLECTION_ADDRESS = "";